module.exports = __webpack_public_path__ + "static/media/empty_extraip.d09a2e61.svg";